module.exports = __webpack_public_path__ + "static/media/copy.38480d09.svg";